// PGCET MCA Mock 4 — Mathematics (questions 1–30)
const pgcetmcaMathematics = [
  {
    id: 1,
    question: "The sum of all natural numbers between 100 and 400 that are divisible by 7 is",
    options: ["A. 10500", "B. 10836", "C. 11025", "D. 10731"],
    answer: "B"
  },
  {
    id: 2,
    question: "The number of positive divisors of 1800 is",
    options: ["A. 18", "B. 24", "C. 36", "D. 48"],
    answer: "C"
  },
  {
    id: 3,
    question: "If log₂(log₃(log₄ x)) = 0, then x equals",
    options: ["A. 16", "B. 81", "C. 256", "D. 64"],
    answer: "D"
  },
  {
    id: 4,
    question: "If one root of the equation x² − px + q = 0 is twice the other, then",
    options: ["A. 2p² = 9q", "B. p² = 3q", "C. 9p² = 2q", "D. p² = 9q"],
    answer: "A"
  },
  {
    id: 5,
    question: "The sum to infinity of the series 1 + 2/3 + 3/9 + 4/27 + 5/81 + … is",
    options: ["A. 3/2", "B. 3", "C. 9/4", "D. 4/3"],
    answer: "C"
  },
  {
    id: 6,
    question: "If ω is a non-real cube root of unity, then (1 − ω + ω²)(1 + ω − ω²) equals",
    options: ["A. 4", "B. 0", "C. 1", "D. −4"],
    answer: "A"
  },
  {
    id: 7,
    question: "If f(x) = (x − 1)/(x + 1), x ≠ −1, then f(f(x)) equals",
    options: ["A. x", "B. −1/x", "C. 1/x", "D. (x + 1)/(x − 1)"],
    answer: "B"
  },
  {
    id: 8,
    question: "The number of onto (surjective) functions from a set with 4 elements to a set with 3 elements is",
    options: ["A. 81", "B. 24", "C. 64", "D. 36"],
    answer: "D"
  },
  {
    id: 9,
    question: "If A is a 3 × 3 matrix with |A| = 4, then |adj(2A)| equals",
    options: ["A. 256", "B. 64", "C. 1024", "D. 512"],
    answer: "C"
  },
  {
    id: 10,
    question: "The rank of the matrix [[1, 2, 3], [2, 4, 6], [1, 1, 1]] is",
    options: ["A. 1", "B. 3", "C. 0", "D. 2"],
    answer: "D"
  },
  {
    id: 11,
    question: "If λ₁ and λ₂ are the eigenvalues of A = [[4, 1], [2, 3]], then λ₁² + λ₂² equals",
    options: ["A. 49", "B. 29", "C. 25", "D. 14"],
    answer: "B"
  },
  {
    id: 12,
    question: "In how many ways can the letters of the word LEADER be arranged so that the vowels always come together?",
    options: ["A. 144", "B. 36", "C. 72", "D. 360"],
    answer: "C"
  },
  {
    id: 13,
    question: "In how many ways can 8 people be seated around a circular table if two particular people must always sit together?",
    options: ["A. 1440", "B. 720", "C. 5040", "D. 2880"],
    answer: "A"
  },
  {
    id: 14,
    question: "The term independent of x in the expansion of (x² − 2/x)⁹ is",
    options: ["A. −5376", "B. 5376", "C. 672", "D. 2688"],
    answer: "B"
  },
  {
    id: 15,
    question: "The value of lim (x → 0) of (eˣ − 1 − x) / x² is",
    options: ["A. 1", "B. 0", "C. ∞", "D. 1/2"],
    answer: "D"
  },
  {
    id: 16,
    question: "The function f(x) = (1 − cos 4x)/x² for x ≠ 0 and f(0) = k is continuous at x = 0. The value of k is",
    options: ["A. 8", "B. 4", "C. 16", "D. 2"],
    answer: "A"
  },
  {
    id: 17,
    question: "If x = a cos³θ and y = a sin³θ, then dy/dx equals",
    options: ["A. tan θ", "B. −tan θ", "C. −cot θ", "D. −tan²θ"],
    answer: "B"
  },
  {
    id: 18,
    question: "The value of c that satisfies Lagrange's Mean Value Theorem for f(x) = x² − 4x on the interval [1, 5] is",
    options: ["A. 2", "B. 4", "C. 3", "D. 2.5"],
    answer: "C"
  },
  {
    id: 19,
    question: "The value of the integral ∫ x sin x dx from 0 to π is",
    options: ["A. π", "B. π/2", "C. 2", "D. 2π"],
    answer: "A"
  },
  {
    id: 20,
    question: "The area of the region enclosed between the curves y = x² and y = x is",
    options: ["A. 1/3", "B. 1/2", "C. 1/12", "D. 1/6"],
    answer: "D"
  },
  {
    id: 21,
    question: "The order and degree of the differential equation (d²y/dx²)³ + (dy/dx)⁴ + y = 0 are respectively",
    options: ["A. 2 and 4", "B. 3 and 2", "C. 2 and 3", "D. 4 and 2"],
    answer: "C"
  },
  {
    id: 22,
    question: "The solution of the differential equation dy/dx + y = e⁻ˣ that satisfies y(0) = 1 is",
    options: ["A. y = x e⁻ˣ", "B. y = (x + 1) e⁻ˣ", "C. y = (x − 1) eˣ", "D. y = e⁻ˣ"],
    answer: "B"
  },
  {
    id: 23,
    question: "The equation of the line passing through the point of intersection of 2x + 3y = 13 and x − y = 4, and perpendicular to 3x − 4y + 7 = 0, is",
    options: ["A. 3x − 4y = 11", "B. 4x − 3y = 17", "C. 3x + 4y = 19", "D. 4x + 3y = 23"],
    answer: "D"
  },
  {
    id: 24,
    question: "The distance between the parallel lines 3x + 4y − 7 = 0 and 6x + 8y + 11 = 0 is",
    options: ["A. 18/5", "B. 5/2", "C. 4/5", "D. 9/10"],
    answer: "B"
  },
  {
    id: 25,
    question: "The length of the tangent drawn from the point (5, 3) to the circle x² + y² − 4x + 2y − 4 = 0 is",
    options: ["A. 16", "B. 2√5", "C. 4", "D. 6"],
    answer: "C"
  },
  {
    id: 26,
    question: "The focus of the parabola x² − 4x − 8y + 12 = 0 is",
    options: ["A. (2, −1)", "B. (4, 1)", "C. (2, 1)", "D. (2, 3)"],
    answer: "D"
  },
  {
    id: 27,
    question: "The value of cos 20° · cos 40° · cos 80° is",
    options: ["A. 1/8", "B. 1/4", "C. 1/16", "D. √3/8"],
    answer: "A"
  },
  {
    id: 28,
    question: "The value of λ for which the vectors 2i − j + k, i + 2j − 3k and 3i + λj + 5k are coplanar is",
    options: ["A. 4", "B. −4", "C. 2", "D. −2"],
    answer: "B"
  },
  {
    id: 29,
    question: "Machines M₁ and M₂ produce 60% and 40% of a factory's output, with defect rates of 2% and 3% respectively. An item picked at random is found to be defective. The probability that it was produced by M₂ is",
    options: ["A. 2/5", "B. 3/5", "C. 1/2", "D. 1/3"],
    answer: "C"
  },
  {
    id: 30,
    question: "The mean and standard deviation of 10 observations are 20 and 2. If each observation is multiplied by 3 and then 5 is subtracted, the new mean and variance are respectively",
    options: ["A. 60 and 36", "B. 55 and 6", "C. 55 and 31", "D. 55 and 36"],
    answer: "D"
  }
];

export default pgcetmcaMathematics;
